KievEnegry.$inject = ['$scope', '$state', '$translate', '$filter', 'Authentication', 'Notification', 'configs', 'PortalApi', '$rootScope', '$stateParams', 'Localization'];

function KievEnegry($scope, $state, $translate, $filter, Authentication, Notification, configs, PortalApi, $rootScope, $stateParams, Localization) {
    var KE_AUTO_LOGIN_KEY = 'ke_auto_login';

    $scope.preLoader = true;
    $scope.showAutoLogin = !!Authentication.isLogged;
    $scope.activeState = '';
    $scope.tariffs = {};   // here the tariff what send KE for place
    $scope.innerStates = {
        AUTH: 'authentication',
        INFO: 'accountInfo',
        COUNTER: 'putCounterValues'
    };

    if($state.params.page == 'dneproblenergo'){
        $scope.dtek = true;
        $scope.services = [];
        $scope.remActive = '';
    }

    $scope.getServices = function () {

        function _toConsumableArray(arr) {
            if (Array.isArray(arr)) {
                for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
                    arr2[i] = arr[i]; }
                return arr2;
            } else {
                return Array.from(arr);
            }
        }
        $scope.servicesIds = [12883].concat(_toConsumableArray(Array.from(Array(35).keys(), function (x) {return x + 12892;})));

        $scope.preLoader = true;

        var data = {
            query: $scope.servicesIds.join(' '),
            limit: $scope.servicesIds.length,
        };

        PortalApi.searchServices(data).then(function(response) {
            $scope.preLoader = false;
            $scope.services = response;
        });
    };

    $scope.authForm = {
        isAuthorised: false,
        login: '',
        password: '',
        auto_login: true,
        abcode: '',
        app: $state.params.page || ''
    };

    $scope.accountInfoShowKeys = [
        'full_name',
        'address',
        'readings_value',
        'last_fee',
        'last_payment',
        'rem',
        'balance',
        // 'power',
        'tariff'
    ];

    $scope.accounts = [];
    $scope.activeAccountInfo = {};
    $scope.activeAccountDetails = {};
    $scope.activeAccount = '';
    $scope.activeInputMask = '';

    $scope.counterValues = [];
    $scope.newValuesDate = '';
    $scope.dates = [];
    $scope.returnButton = true;


    if($rootScope.useFrame && $state.current.data.iframe == false){
        document.body.classList.remove('bodyContainer');
        $state.go('pages.error404');
        $rootScope.useFrame = false;
    }

    $scope.backToChoose = function() {
        $scope.authForm.app = '';
        $state.go('pages.myelectricity', {page: ''});
    };

    $scope.maxInputValue = function (data) {
      var value = '';
      if (data.counter_scale) {
          for (var i = 0; i < data.counter_scale; i++) {
            value += "9";
          }
      } else {
          value = "99999";
      }
      $scope.activeInputMask = value;
    }

    if ($state.params.page) {
      PortalApi.isAuthorised($state.params.page).then(function(response) {
        if (response.isAuthorised) {
          $scope.authForm.isAuthorised = true;
          $scope.getToken();
        }
        $scope.authForm.app = $state.params.page;
      });
    }

    $scope.changeInnerState = function (state) {
        $scope.activeState = state || $scope.innerStates.AUTH;
    };

    $scope.getToken = function () {
        $scope.preLoader = true;

        if (!Authentication.isLogged) {
            $scope.authForm.auto_login = false;
        }

        PortalApi.keLogin($scope.authForm).then(function(res) {
            res = res.plain();

            if(res.serviceId){
                $scope.remActive = res.serviceId;
                $scope.oldRem = res.serviceId;
            }

            if($state.params.page == 'dneproblenergo') {

                $scope.abcode = res.info.abcode;

                var rem = {
                    info: {
                        rem:  $scope.services[0]
                    }
                };
                res = angular.merge(res, rem);
            }

            if (res.status == 'error' || res.code !== void 0) {

                if (res.text) {
                    Localization.notifyTemplate('error', 'ERRORS.' + res.text, 5, true);
                } else {
                    Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.CANNOT_AUTH', 5, true);
                }

            } else if (!res.auth.accounts.length) {
                Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.NO_BILLS_ON_ACC', 5, true);
            } else {
                $scope.activeAccountInfo = res.info;
                $scope.activeAccountDetails = res.details;
                $scope.returnButton = false;

                $scope.maxInputValue($scope.activeAccountInfo);

                // pars tariffs
                if (res.info.tariff) {
                    var tariffMass = res.info.tariff.split(":");

                    $scope.livePlace = tariffMass.splice(0,1).toString();

                    tariffMass[0].split(',').forEach(function(element, index){
                        $scope.tariffs[index] = element;
                    });
                }

                $scope.accounts = res.auth.accounts;
                $scope.activeAccount = $scope.activeAccountInfo.abcode;
                $scope.authForm.password = '';

                $scope.changeInnerState($scope.innerStates.INFO);
                setToStorage(KE_AUTO_LOGIN_KEY, $scope.authForm.auto_login);
            }
        }, function() {
            Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.AUTH_FAIL', 5, true);
        }).finally(function() {
            $scope.preLoader = false;
        });
    };

    $scope.logout = function () {
        $scope.preLoader = true;

        PortalApi.keLogout($scope.authForm.app).then(function(res) {
            $scope.activeAccountInfo = {};
            $scope.activeAccountDetails = {};
            $scope.accounts = [];
            $scope.authForm.app = '';
            $scope.authForm.login = '';
            $scope.authForm.isAuthorised = false;
            $scope.changeInnerState($scope.innerStates.AUTH);
            $scope.returnButton = true;
        }, function() {

        }).finally(function() {
            $scope.preLoader = false;
            $state.go('pages.myelectricity', {page: null});
        });
    };

    $scope.getAccountInfo = function (d) {

        if ($scope.innerStates.AUTH === $scope.activeState) {
            return;
        }

        $scope.preLoader = true;

        PortalApi.keGetAccountInfo($scope.activeAccount, $scope.authForm.app).then(function(res) {
            res = res.plain();
            $scope.activeAccountInfo = res.info;
            $scope.activeAccountDetails = res.details;
            $scope.changeInnerState($scope.innerStates.INFO);
            $scope.maxInputValue($scope.activeAccountInfo);
        }, function() {
            Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.AUTH_FAIL', 5, true);
        }).finally(function() {
            $scope.preLoader = false;
        });
    };

    $scope.putCountersValues = function () {
        var data = {
            app: $scope.authForm.app,
            abcode: $scope.activeAccount,
            counter1: $scope.counterValues[0][1],
            counter2: $scope.counterValues[1] ? $scope.counterValues[1][1] : 0,
            counter2: $scope.counterValues[2] ? $scope.counterValues[2][1] : 0,
            date: $scope.newValuesDate
        };

        $scope.preLoader = true;

        PortalApi.kePutCountersValue(data).then(function(res) {
            res = res.plain();

            if (res.counters.result !== 'success') {
                Localization.notifyTemplate('error', 'KIEVENERGY.limite_error', 5, true);
            }

            $scope.activeAccountInfo = res.info;
            $scope.changeInnerState($scope.innerStates.INFO);
        }, function() {

            Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.COUNTER_INPUT_FAIL', 5, true);

        }).finally(function() {
            $scope.preLoader = false;
        });
    };

    $scope.bindService = function (id) {
        $scope.remActive = id;
    };

    $scope.toService = function (servId) {
        $state.go('pages.payment', {
            autoCheck: true,
            // counters: $scope.newCounter || null,
            lastDate: $scope.activeAccountInfo.last_fee.datefee,
            account: $scope.activeAccount,
            lastCounter: $scope.readings_value,
            serviceId: servId,
            url: servId,
            amount: $scope.activeAccountInfo.balance < 0 ? Math.abs($scope.activeAccountInfo.balance) : 0
        });
    };

    $scope.pay = function () {
        var servId;

        if ($scope.authForm.app == 'dneproblenergo') {

            if($scope.remActive){

                servId = $scope.remActive;

                if($scope.oldRem != $scope.remActive){

                    var data = {
                        serviceId: $scope.remActive,
                        abcode: $scope.activeAccount,
                        app: $scope.authForm.app
                    };

                    PortalApi.bindService(data).then(function(response) {

                    });
                }

                $scope.toService(servId);

            }else{

                Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.BIND_REM', 5, true);

            }
        } else {

            servId = configs.payments_config.energyCalc.kievEnergoElectricity;
            $scope.toService(servId);

        }
    };

    $scope.initPutCounterState = function () {
        var values = $scope.activeAccountInfo.readings_value.split('/');
        var nowDate = new Date();
        var i = 0;

        $scope.counterValues = [];
        $scope.dates = [];

        values.forEach(function (value, i) {
            value = parseInt(value);
            $scope.counterValues[i] = [value, value];
        });

        // 09.2018 old type add dates
        // for (; i < 5; i++) {
        //     $scope.dates.push(
        //         $filter('date')(nowDate - i * (24 * 60 * 60 * 1000), 'dd.MM.yyyy')
        //     );
        // }

        $scope.dates = $scope.activeAccountDetails.available_dates.reverse();

        $scope.newValuesDate = $scope.dates[0];

        $scope.changeInnerState($scope.innerStates.COUNTER);
    };

    function init() {
        var autoLogin = getFromStorage(KE_AUTO_LOGIN_KEY);
        $scope.changeInnerState($scope.innerStates.AUTH);

        if($state.params.page == 'dneproblenergo'){
            $scope.getServices();
        }

        if (autoLogin !== null) {
            $scope.authForm.auto_login = autoLogin = (autoLogin === 'true');
        }

        if (Authentication.isLogged && !!autoLogin) {
            $scope.getToken();
        } else {
            $scope.preLoader = false;
        }
    }

    //TODO move cash to stand alone service
    function getFromStorage(key) {
        return localStorage.getItem(key);
    }

    function setToStorage(key, value) {
        return localStorage.setItem(key, value);
    }

    init();

    if($state.params.page == 'dneproblenergo'){
        $rootScope.$on('changeLang', $scope.getServices);
    }

}


module.exports = KievEnegry;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myElectricity/controllers/ke.controller.js
 ** module id = 274
 ** module chunks = 1
 **/